module.exports = __webpack_public_path__ + "media/conmex/biblioteca-f6677293.png";